import { Text } from "@clipboard-health/ui-components";
import { Stack } from "@mui/material";

interface ScoreDisplayProps {
  score: number;
  /**
   * Controls the color of the score text
   * - "penalized": red/error color (default)
   * - "credit-applied": primary text color
   */
  variant?: "penalized" | "credit-applied";
}

export function ScoreDisplay(props: ScoreDisplayProps): JSX.Element {
  const { score, variant = "penalized" } = props;

  return (
    <Stack alignItems="center" justifyContent="center" sx={{ paddingY: 4 }}>
      <Text
        variant="h1"
        color={(theme) =>
          variant === "credit-applied"
            ? theme.palette.text.primary
            : theme.palette.intent?.error.text
        }
        sx={{
          fontSize: "7.25rem",
          fontWeight: 300,
          lineHeight: "96px",
          letterSpacing: "-0.01em",
        }}
      >
        {score}
      </Text>
    </Stack>
  );
}
